// Mock data for Sea Spice Kitchen - Coastal Fusion Restaurant

export const restaurantInfo = {
  name: "Sea Spice Kitchen",
  tagline: "Where Coastal Freshness Meets Global Flavour",
  shortDesc: "Frankston's Home of Coastal Fusion Dining",
  address: {
    line1: "1/432 Nepean Highway",
    line2: "Frankston VIC 3199",
    country: "Australia"
  },
  phone: "+61 3 7057 2373",
  phoneDisplay: "(03) 7057 2373",
  email: "reception@seaspicekitchen.com.au",
  hours: {
    weekdays: "6:30 AM – 11:30 PM",
    weekends: "6:30 AM – 11:30 PM",
    closed: "Seven Days Open"
  },
  socials: {
    instagram: "@seaspicekitchen",
    facebook: "seaspicekitchen"
  }
};

export const heroImages = [
  "/image/siteimages/gallery/photo-1595579547936-c3a0e6c171fc.jpg",
  "/image/siteimages/gallery/photo-1651323018466-b36b7df1d2b1.jpg"
];

export const menuHighlights = [
  {
    id: 1,
    category: "From The Grill",
    name: "Sizzlin Garlic King Prawns",
    description: "Twelve succulent king prawns served sizzling hot with garlic and aromatic herbs.",
    price: "$34.00",
    image: "/image/highlights/Sizzlin Garlic King Prawns.jpg",
    signature: true
  },
  {
    id: 2,
    category: "From The Grill",
    name: "Chicken Scallopini",
    description: "Grilled chicken breast served with garlic herb potatoes, char-grilled broccoli and creamy mushroom bacon sauce.",
    price: "$28.00",
    image: "/image/highlights/Chicken Scallopini.jpg"
  },
  {
    id: 3,
    category: "Breakfast",
    name: "Berry Brioche French Toast",
    description: "Vanilla cinnamon custard brioche topped with mixed berry compote and whipped cream.",
    price: "$24.00",
    image: "/image/highlights/Berry brioche french toast.jpg"
  },
  {
    id: 4,
    category: "Mains",
    name: "Barramundi",
    description: "Grilled barramundi served with chips, salad and honey mustard sauce.",
    price: "$34.00",
    image: "/image/highlights/Barramundi.jpg",
    signature: true
  },
  {
    id: 5,
    category: "Mains",
    name: "Pork Ribs",
    description: "Slow-cooked pork ribs served with chips and salad.",
    price: "$35.00",
    image: "/image/highlights/Pork Ribs.jpg",
    signature: true
  },
  {
    id: 6,
    category: "Mains",
    name: "Southern Fried Chicken Burger",
    description: "Southern fried chicken, American cheese and chef's special sauce served on a brioche bun with chips.",
    price: "$25.00",
    image: "/image/highlights/Southern Fried Chicken Burger.jpg",
    signature: true
  }
];
export const fullMenu = {
  "Breakfast": [
    {
      name: "Egg And Bacon Roll",
      desc: "Fried egg, crispy bacon, cheese and maple bourbon BBQ sauce on a soft roll.",
      price: "$12.00"
    },
    {
      name: "Bacon Egg Halloumi Roll",
      desc: "Crispy bacon, fried egg, grilled halloumi with house romesco sauce on a toasted bagel.",
      price: "$14.00"
    },
    {
      name: "Sausage Egg And Romesco Breakfast Roll",
      desc: "Sausage, fried egg and romesco sauce on a soft roll.",
      price: "$14.00"
    },
    {
      name: "Eggs Your Way",
      desc: "2 eggs (poached, fried or scrambled) served with sourdough toast.",
      price: "$15.50"
    },
    {
      name: "Big Breakfast",
      desc: "2 eggs your way, chorizo, mushroom, bacon, spinach, roast tomato, halloumi, sourdough toast.",
      price: "$25.80"
    },
    {
      name: "Avocado Toast",
      desc: "2 poached eggs, smashed avocado, multigrain toast, fresh tomato, dukkah.",
      price: "$21.80"
    },
    {
      name: "Golden Waffles",
      desc: "Crispy buttermilk fried chicken, tangy bacon, drizzled with maple syrup.",
      price: "$24.00"
    },
    {
      name: "Berry Brioche French Toast",
      desc: "Vanilla cinnamon custard brioche, mixed compote, whipped cream.",
      price: "$24.00"
    },
    {
      name: "Fluffy Buttermilk Pancakes",
      desc: "Seasonal fruit, mixed berry compote, maple syrup, powdered sugar.",
      price: "$24.00"
    }
  ],

  "From The Grill": [
    {
      name: "Chicken Scalopini",
      desc: "With garlic herb potatoes, char grilled broccoli topped with a creamy mushroom and bacon sauce.",
      price: "$28.00"
    },
    {
      name: "Sizzling Garlic King Prawns",
      desc: "12 king prawns tossed with garlic.",
      price: "$34.00"
    }
  ],

  "Indian Style": [
    {
      name: "Murgh And Gosht",
      desc: "Mild chicken or curry in mango flavoured sauce finished with coconut cream.",
      price: "$23.00"
    },
    {
      name: "Roganjosh",
      desc: "North Indian style boneless lamb cooked in a rich spicy tomato and onion sauce.",
      price: "$23.00"
    },
    {
      name: "Chicken Tikka Korma",
      desc: "Tandoori chicken in mild creamy cashew and coconut sauce.",
      price: "$24.00"
    },
    {
      name: "Saag Gosht",
      desc: "Tender lamb cooked with fresh spinach, ginger, cashews and spices.",
      price: "$23.00"
    },
    {
      name: "Malai Kofta",
      desc: "Vegetable balls in rich creamed spinach, onion gravy and mild spices.",
      price: "$21.00"
    },
    {
      name: "Paneer Butter Masala",
      desc: "Cottage cheese cooked in a rich tomato, cream and butter sauce.",
      price: "$21.00"
    },
    {
      name: "Dal Makhni",
      desc: "Black lentils and kidney beans simmered in a creamy ginger spiced sauce.",
      price: "$21.00"
    },
    {
      name: "Shahi Paneer",
      desc: "Cottage cheese cooked in a creamy sauce finished with cashews and fenugreek leaves.",
      price: "$21.00"
    }
  ],

  "Mains": [
    {
      name: "Chicken Wings",
      desc: "Choose your style: Lemon Pepper, Hot Honey, Garlic Parmesan or Korean.",
      price: "6pc $16 / Full $32"
    },
    {
      name: "Salt & Pepper Calamari",
      desc: "Flash fried, served with chips, salad, garlic aioli and lemon.",
      price: "$26.90"
    },
    {
      name: "Barramundi",
      desc: "Grilled barramundi, chips, salad and honey mustard sauce.",
      price: "$34.00"
    },
    {
      name: "Pork Ribs",
      desc: "Slow-cooked pork ribs served with chips and salad.",
      price: "$35.00"
    },
    {
      name: "Southern Fried Chicken Burger",
      desc: "Southern fried chicken, American cheese, chef special sauce with honey glazed bacon on a brioche bun.",
      price: "$25.00"
    },
    {
      name: "Jalapeno Popper Burger",
      desc: "Char-grilled wagyu beef patty, American cheese, tomato, lettuce, fried egg and bacon on a brioche bun.",
      price: "$25.00"
    },
    {
      name: "Maiale Croccante",
      desc: "Pork belly pieces, crispy crackling, spicy sticky sauce, rosemary and sage vegetables.",
      price: "$32.00"
    }
  ],

  "Pasta": [
    {
      name: "Bolognese",
      desc: "Mince, Napoli, water, pasta, garnish parsley and parmesan.",
      price: "$22.00"
    },
    {
      name: "La Pasta Meravigliosa",
      desc: "Pasta with chicken, mushrooms, olives, sun-dried tomatoes, pine nuts, cream and parmesan.",
      price: "$25.00"
    },
    {
      name: "Gamberi Rabbiosi",
      desc: "Pappardelle pasta, chilli prawn and calamari in creamy garlic sauce.",
      price: "$25.00"
    },
    {
      name: "Carbonara Con Pollo",
      desc: "Rigatoni pasta, chicken, bacon and creamy sauce.",
      price: "$22.00"
    },
    {
      name: "Boscaiola Classica",
      desc: "Rigatoni pasta, bacon, mushrooms and creamy sauce.",
      price: "$22.00"
    }
  ],

  "Bread From The Tandoor": [
    {
      name: "Tandoori Kulcha Naan",
      desc: "Stuffed with tandoori tikka and Taj's cheese.",
      price: "$6.90"
    },
    {
      name: "Pishwari Naan",
      desc: "Sweet naan bread with coconut and sultanas.",
      price: "$6.90"
    },
    {
      name: "Naan",
      desc: "Plain flour bread from the clay oven.",
      price: "$5.90"
    },
    {
      name: "Garlic Naan",
      desc: "Fresh garlic, coriander and butter.",
      price: "$5.90"
    },
    {
      name: "Aloo Kulcha",
      desc: "Stuffed with garlic, peas, coriander and spices.",
      price: "$6.90"
    },
    {
      name: "Roti",
      desc: "Wholemeal flour bread.",
      price: "$6.90"
    },
    {
      name: "Paneer Naan",
      desc: "Stuffed with Taj's special cheeses.",
      price: "$6.90"
    },
    {
      name: "Pappadums",
      desc: "4 pieces.",
      price: "$5.90"
    }
  ],

  "Rice": [
    {
      name: "Rice",
      desc: "Basmati rice cooked with a touch of Indian herbs.",
      price: "$5.90"
    },
    {
      name: "Kashmiri Pulao",
      desc: "Fluffy saffron rice with a touch of dried fruits.",
      price: "$5.90"
    },
    {
      name: "Green Peas Pulao",
      desc: "Saffron rice cooked with green peas and mild spices.",
      price: "$6.90"
    },
    {
      name: "Mushroom Pulao",
      desc: "Basmati rice cooked with mushrooms and mild spices.",
      price: "$6.90"
    }
  ],

  "Sides & Add Ons": [
    {
      name: "Chips",
      desc: "Crispy golden chips.",
      price: "$7.00"
    },
    {
      name: "Garlic Aioli",
      desc: "House-made garlic aioli.",
      price: "$2.00"
    },
    {
      name: "Side Salad",
      desc: "Fresh garden salad.",
      price: "$6.00"
    },
    {
      name: "Garlic Herb Potatoes",
      desc: "Roasted potatoes with garlic and herbs.",
      price: "$8.00"
    },
    {
      name: "Steamed Greens",
      desc: "Seasonal steamed vegetables.",
      price: "$6.00"
    }
  ],
  "Kids Menu": [
  {
    name: "Nuggets & Chips",
    desc: "Kids meal served with chicken nuggets and chips.",
    price: "$12.00"
  },
  {
    name: "Linguine Bolognese",
    desc: "Kids-sized linguine pasta with traditional bolognese sauce.",
    price: "$12.00"
  },
  {
    name: "Calamari & Chips",
    desc: "Lightly fried calamari served with chips.",
    price: "$14.00"
  },
  {
    name: "Fish & Chips",
    desc: "Crispy battered fish served with chips.",
    price: "$12.00"
  },
  {
    name: "Schnitzel & Chips",
    desc: "Chicken schnitzel served with chips.",
    price: "$14.00"
  },
  {
    name: "Parma & Chips",
    desc: "Chicken parma served with chips.",
    price: "$14.00"
  }
]
};

export const galleryImages = [
  { src: "/image/siteimages/gallery/photo-1517248135467-4c7edcad34c4.jpg", caption: "Main Dining Room" },
  { src: "/image/siteimages/gallery/photo-1667388969250-1c7220bf3f37.jpg", caption: "Open Kitchen" },
  { src: "/image/siteimages/gallery/pexels-photo-2387675.jpg", caption: "Lounge & Bar" },
  { src: "/image/siteimages/gallery/photo-1595579547936-c3a0e6c171fc.jpg", caption: "Seafood Platters" },
  { src: "/image/siteimages/gallery/photo-1759027044799-5aed5577f864.jpg", caption: "Coastal Curries" },
  { src: "/image/siteimages/gallery/pexels-photo-31071253.jpg", caption: "Private Dining" },
  { src: "/image/siteimages/gallery/pexels-photo-566343.jpg", caption: "Grill Selection" }
];

export const testimonials = [
  {
    name: "Emily R.",
    location: "Mornington",
    text: "The Tandoori King Prawns are out of this world. Every dish felt fresh, vibrant and beautifully presented. Frankston's best-kept secret!",
    rating: 5
  },
  {
    name: "David & Anna",
    location: "Frankston South",
    text: "Came for our anniversary — the staff went above and beyond. The lobster was perfectly cooked and the saffron crème brûlée was divine.",
    rating: 5
  },
  {
    name: "Priya K.",
    location: "Melbourne",
    text: "The fusion of Indian spices with Mediterranean techniques is brilliant. The Kerala prawn curry took me right back home.",
    rating: 5
  }
];

export const coastalFusionPoints = [
  { title: "Fresh Australian Seafood", desc: "Sourced daily from local Victorian fisheries and prepared with global influences." },
  { title: "Traditional, Reimagined", desc: "Classic recipes elevated with modern techniques and refined presentation." },
  { title: "Authentic Indian Spices", desc: "House-toasted, hand-ground spices balanced with contemporary Australian cuisine." },
  { title: "Mediterranean Freshness", desc: "Bright, herb-forward flavours and simple, ingredient-led cooking." },
  { title: "Seasonal & Local", desc: "Produce sourced from Mornington Peninsula farms whenever possible." },
  { title: "Tradition Meets Innovation", desc: "A dining experience that honours heritage while embracing creativity." }
];
